<template>
  <div class="col-xs p0">
    <div class="best-seller item-label c-bg-red c-white align-center justify-center flex fs12 lh15 ml45 pt20 pb6 relative">
      <div class="text-wrapper c-bg-red flex flex-row align-items-center w-100 between-sm hidden-mobile">
        <span class="hidden-mobile">{{ $t('Best selling event on our website') }}</span>
        <tooltip
          :title="tooltipTitle"
          :text="tooltipText"
          icon="icon-ev-warning-white"
          active-icon="icon-ev-warning-white"
        />
      </div>
    </div>
    <div
      class="clickable-area align-center hidden-tablet hidden-desktop text-wrapper c-bg-red c-white fs12 flex flex-row ml45 py6
             relative justify-center"
    >
      <span class="text-center pl7">{{ $t('This is one of the best selling events on our website') }}</span>
      <tooltip
        :title="tooltipTitle"
        :text="tooltipText"
        icon="icon-ev-warning-white"
        active-icon="icon-ev-warning-white"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Tooltip from 'theme/components/common/Tooltip.vue'

export default {
  name: 'BestSeller',
  components: {
    Tooltip
  },
  props: {
    productSku: {
      type: String,
      required: true
    },
    artist: {
      type: Object,
      default: null
    }
  },
  computed: {
    ...mapGetters({
      getConfigs: 'magentoConfig/getValue'
    }),
    artistName () {
      return this.artist ? this.artist.name : ''
    },
    getBestSellerPercentage () {
      return this.getConfigs('catalog/bestselling_event/bestselling_percentage')
        ? this.getConfigs('catalog/bestselling_event/bestselling_percentage') : '25'
    },
    tooltipTitle () {
      return this.$t('Best selling event')
    },
    tooltipText () {
      return this.$t('This event is among the best selling events with {artistName}', { artistName: this.artistName })
    }
  },
  methods: {
    showBestSellerPopupWindow () {
      this.$store.commit('ui/setShowBestSellerPopup', this.productSku)
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~theme/css/variables/colors';
@import '~theme/css/helpers/functions/color';
@import '~theme/css/variables/grid';
@import '~theme/css/helpers/functions/z-index-selectors';

@include mobile {
  .item-label {
    z-index: zIndex(banner-image);
    margin-top: -12px;
  }

  .clickable-area {
    border-radius: 0 0 10px 10px;
    box-shadow: 0 3px 4px 0 rgba(0, 0, 0, 0.25);
    top: -14px;
  }

  .text-center {
    padding-right: 6px;
  }
}

/deep/ .icon-ev-warning-white {
  height: 11px;
  width: 11px;
}

@include mediaQuery(sm) {
  .item-label {
    position: absolute;
    border-radius: 4px 0 0 4px;
    width: 126px;
    padding: 0;
    right: -7px;
    bottom: 63px;
    text-align: left;
    z-index: zIndex(banner);

    .text-wrapper {
      padding: 3px 7px;
      z-index: zIndex(banner);
      border-radius: 4px 0 0 4px;

      .icon-ev-warning-white {
        display: block;
        height: 11px;
        min-width: 11px;
      }
    }

    &::after {
      content: '';
      position: absolute;
      background-color: #7d0009;
      z-index: zIndex(header);
      bottom: -3px;
      right: 0;
      width: 7px;
      height: 12px;
      transform: skewY(316deg);
    }
  }
}
</style>
